<template>
    <CSidebar fixed
              :minimize="minimize"
              :show.sync="show">
        <!-- new custom menu bar -->
        <div @mouseover="hover = true" @mouseleave="hover = false">
            <ul class="c-scroll-area p-0 m-0 ps" style="position: relative;z-index: 5;">
                <li class='user-profile'>
                    <CRow class="mx-0 user-detail">
                        <CCol md="12" class="new-profile mb-2">
                            <div class="new-profile-iconbg">
                                <div class="custom_tooltip">
                                    <span v-if="this.getUserInfo.AT == 0" class="fa fa-user-shield gg-ico gg-ico-ssa"></span>
                                    <span v-if="this.getUserInfo.AT == 1" class="fa fa-user-alt gg-ico gg-ico-sa"></span>
                                    <span v-if="this.getUserInfo.AT == 2" class="fa fa-user-friends gg-ico gg-ico-ma"></span>
                                    <span v-if="this.getUserInfo.AT == 3" class="fa fa-users gg-ico gg-ico-a"></span>
                                    <span v-if="this.getUserInfo.AT == 4 && !this.getUserInfo.IOL" class="fa fa-users gg-ico gg-ico-sag pr-0"></span>
                                    <span v-if="this.getUserInfo.AT == 4 && this.getUserInfo.IOL" class="fa fa-users gg-ico gg-ico-outlet pr-0"></span>
                                    <div class="tooltiptext2" style=" width: 100px; bottom: auto; top: 180%; height: 20px; left: 100%;"> {{ this.getUserInfo.RN }}</div>
                                </div>
                            </div>
                            <div class="text-left" style=" font-size: 12px;">
                                <div class="font-weight-bold text-white" :class="getUserInfo.RS == 3 ? 'freeze-user' : ''">
                                    {{ this.getUserInfo.DN }} ({{ this.getUserInfo.PC }})
                                    <i class="cil-snowflake freeze" v-if="getUserInfo.RS == 3"></i>
                                </div>
                                <div class="d-flex justify-content-start align-items-center">
                                    <router-link :to="{ path: '/AGS/BalanceHistory', query: this.$route.path == '/AGS/BalanceHistory' ? { agi: this.getUserInfo.AT + '-' + this.getUserInfo.AGI } : {} }">
                                        <div class="text-secondary ml-0" @click="redirectToCreditHistory">
                                            <span v-if='this.getBalanceStatus == 1'><a href="#" class="ml-0">{{ formatNumber(this.getSystemBalance, 2, this.getCurrencySymbol) }}</a></span>
                                            <span v-if='this.getBalanceStatus == 2' class="warningbalance ml-0">{{ formatNumber(this.getSystemBalance, 2, this.getCurrencySymbol) }}</span>
                                            <span v-if='this.getBalanceStatus == 3' class="balanceflash ml-0">{{ formatNumber(this.getSystemBalance, 2, this.getCurrencySymbol) }}</span>
                                            <span v-if='this.getBalanceStatus == 4' class="balanceflash ml-0">{{ formatNumber(this.getSystemBalance, 2, this.getCurrencySymbol) }}</span>
                                        </div>
                                    </router-link>
                                </div>
                                <div v-if='this.getUserInfo.AT == 4 && this.getUserInfo.IOL == 0 && this.getUserInfo.SARL != null && this.getUserInfo.SARL != ""' class='user-detail-row mb-1'>
                                    <div class="text-secondary ml-0">
                                        <span v-on:click="copyReferralLink()" class="pointer ml-0">{{this.getLanguage["MEM"]["RIURL"]}} <i class="fas fa-copy" style="display: inline-block; font-size: 1em; width: 12px; height: 12px; margin-right: auto; margin-left: 5px;"></i></span>
                                    </div>
                                </div>
                            </div>
                        </CCol>

                        <CCol md="12" class="menuOption">
                            <div class="row mx-0" :style="checkModuleAccess('ASS', 'AGS', constAccessType.view) ? 'display: grid; grid-template-columns: 50% 50%;': 'display: grid;grid-template-columns: 100%;'">
                                <router-link :to="{ path: '/CustomizeMenu' }" class="ml-0 text-white position-relative" >
                                    <div class="rounded-icon" :class="(this.$route.path == '/AGS/AGD' || this.$route.path == '/AGS/ASS') ? '': 'active'">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="15" height="15" viewBox="0 0 15 15" fill="none">
                                            <rect width="15" height="15" fill="url(#pattern0_503_35)" />
                                            <defs>
                                                <pattern id="pattern0_503_35" patternContentUnits="objectBoundingBox" width="1" height="1">
                                                    <use xlink:href="#image0_503_35" transform="scale(0.0208333)" />
                                                </pattern>
                                                <image id="image0_503_35" width="48" height="48" preserveAspectRatio="none" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAPySURBVGhD7ZpdiFVVFMcdFPNlCpR0QrTIKT9i6K0Ew8pRQWGqeRN98PMtQcToJUrxwQc/CKKIREMUkQmHaYy+hXkoQYhUZMwEv/qiCHWoQYXA34p1W3fYZ7XvufueOx8y3B+slzNr/fda95yz9177zIQJBvAMsFVEdhQx4DXgRRFpKmvGAB4GVgFveo0UA94C1otISyi6BfgeuC0FAe4CF7QQEXkok7UBtAFHgF+Be14jBf7jT+ArYL6Krgcue8eiAANAh09eRCYC+71/PQBvaAFXgDv+j/UAvA00hwUAC4B+71sPwMf6y/iL7wIbazSNuRFodAOzXAEdwLXA5yzwekSrmp0JNPpiBSwJB05BY4CrgUaviDzmfDqBn4KhPgIeDH1SALqCcf5fgIi84oOqoTHA9bKA3lrg0Vp9UgB6Ao1GASVSkkvxSaFRQIyU5FJ8UmgUECMluRSfFBoFxEhJLsUnhfFfALDCB1VDY9w+p9cnFylA90vTQ58UgOOBRrSA7cBiYFmi6T5IY/4INLpFZLYb+GVX5ClgjcV7zUr2PPBtoNGnwjeBf4KL2mz0Az8m2g8WE2p8AEx1BSwELgY+g9qHWLzXrGSa12Cg8ZkK7wV+L18cDoAN2sC4ApqBE963HoB9KvwIsFv7NO9QBOBD7XvD5MuIyAvAeR9TBH2fgEVl4RZgE3AQ+BI4CXydaOr7OXAY2Kw/iE88BHgW2GUvsfa1tY71CbAHWO7vsopPA57UZllE5qUa8AQwIyOWg4hM0pccmOu18szyehx4wGs2aDAc2PPfri9IZBHJM41p83qjBvAU8A7wjS0slyKLSJ5pzGngAPC01x9R7LjvqJ9ni6LLO9Dqx0lFV3Cbjt/Xu6szlvfJABwDbvlE6sEOiSf7sVIAtgF/m45uHfLvqB3KDh20AueATyOLSCX7wmLC48lDlVbjatihWEj+9t45awGv6iPgF5FKZi++xvwWaPT47XQq2ie4fDq9T4bQ2QJGpB9IJWxYjNruQNWACJFmpVC3pYyHAoYOb02r3ftkCJ2NES/Apkp9b3Td8DakY1o6UXif90RkaWk3Gjobo1GAfk/7KztsbdgU2zpWBfjnvBClhsZfHKUCtJn/OTtsbdj6M3NMChCRKXYa4T8fZT4hmVbsk9daa4aaxqSAPCKzUP4nr9DZGOsC/PuRn49zrh4Q4b4qoOrCEcEamtyvlKnUvBfSnWh4JlRh4ahmGhOemHWVZogC2LHkEMBL3icD8F29i4oH2KkzjR8rBWA18Ivp6BnVHO+TwQ5yz/kkimKP0nN+nFRsim0XkXW2Zc/975cSwErbAg/4hFKxw1o9Oess+usX4V/Qed4KXV30qgAAAABJRU5ErkJggg==" />
                                            </defs>
                                        </svg>

                                        {{this.getLanguage["DB"]["MENU"]}}

                                        <div>
                                            <template v-if="this.getUserInfo.MS === 1">
                                                <span class="badge badge-warning rounded-circle text-white" style="padding-top: 4px;">F</span>
                                            </template>
                                            <template v-else-if="this.getUserInfo.MS === 2">
                                                <span class="badge badge-warning rounded-circle text-white" style="padding-top: 3px;">S</span>
                                            </template>
                                            <template v-else-if="this.getUserInfo.MS === 3">
                                                <span class="badge badge-warning rounded-circle text-white" style="padding-top: 3px;">C</span>
                                            </template>
                                        </div>
                                    </div>
                                </router-link>
                                <div class="custom_tooltip" v-if="checkModuleAccess('ASS', 'AGS', constAccessType.view)">
                                    <div class="tooltiptext2" style="width: 250px; bottom:80% !important; height: 60px; right: 5%; left: auto; "> {{getLanguage["AG"]["SSAWLCMSG"]}}</div>
                                    <router-link :to="{ path: '/AGS/AGD', query: this.$route.path == '/AGS/AGD' ? { rst: 1 } : {} }" class="ml-0 text-white" >
                                        <div class="rounded-icon" :class="(this.$route.path == '/AGS/AGD' || this.$route.path == '/AGS/ASS') ? 'active': ''" style="padding: 0px 9px;">
                                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="15" height="15" viewBox="0 0 15 15" fill="none">
                                                <rect width="15" height="15" fill="url(#pattern0_503_36)" />
                                                <defs>
                                                    <pattern id="pattern0_503_36" patternContentUnits="objectBoundingBox" width="1" height="1">
                                                        <use xlink:href="#image0_503_36" transform="scale(0.0208333)" />
                                                    </pattern>
                                                    <image id="image0_503_36" width="48" height="48" preserveAspectRatio="none" xlink:href="data:image/png;base64,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" />
                                                </defs>
                                            </svg>
                                            {{getLanguage["AG"]["AGENTSS2"]}}
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </CCol>
                    </CRow>
                </li>
                <li class="c-sidebar-nav-dropdown activeLvl1" :class="[($parent.showSubMenu == 'FAV' || isFirstLoad ? 'c-show' : '')]" v-if="favMenuList!=null && favMenuList.length>0" style="font-size: 12px">
                    <a class="c-sidebar-nav-dropdown-toggle" v-on:click="changeShowSubMenu('FAV')">
                        <i class="fas fa-star" style="color: yellow;"></i>
                        <div class="menu-Name">
                            <span>{{ this.getLanguage["SMB"]["FAV"] }}</span>
                        </div>
                    </a>
                    <ul class="c-sidebar-nav-dropdown-items d-sm-down-none" :class="(isMinimize && minimize) ? 'd-none' :''" style="font-size: 12px; padding-left: 0px">
                        <li class="c-sidebar-nav-item" v-for="(data, index) in favMenuList" :class="{ 'menuActive' : $parent.showActiveMenu == data.PM + '.' + data.MN }" v-if="data.IHM == false">
                            <router-link :to="'/'+ data.PM + '/'+ data.MN" :target="(data.MN == 'CRMDU' || data.MN == 'LCHAT' || data.MN == 'VG' || data.MN == 'UM')?'_blank':'_self'">
                                <a id="subSubMenu" class="c-sidebar-nav-link" @click="addMenuToFavorite(data,checkModuleIndex(data.MN, data.PM, constAccessType.view),false,null,true)">
                                    <div class="dropdown-Name">
                                        <!--<span v-if="data.MID">{{ data.MID }}</span>
                                        <span v-else>{{ checkModuleIndex(data.MN, data.PM, constAccessType.view) }}</span>-->
                                        <span>{{ checkModuleIndex(data.MN, data.PM, constAccessType.view, '', (data.SPM ? -1 : 0)) }}</span>
                                        <span>{{ getLanguageOEMI(int_OEMId,"SMB",data.MN) }}</span>
                                        <span><i :class="data.IFM?'fas fa-star mr-0':'far fa-star mr-0'" @click.stop="event=>addMenuToFavorite(data,checkModuleIndex(data.MN, data.MN, constAccessType.view),true,event,true)"></i></span>
                                    </div>
                                </a>
                            </router-link>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>

        <div class="scroll" @mouseover="hover = true" @mouseleave="hover = false">
            <ul class="c-scroll-area c-sidebar-nav ps" style="position: relative;z-index: 5;">
                <template v-for="(menuTitle, index) in obj_menuTitle">
                    <li v-if="menuTitle.C == false && checkMenuAccess(menuTitle.MN) && menuTitle.HSM == false && menuTitle.IHM == false" class="c-sidebar-nav-dropdown" :class="[($parent.showSubMenu == menuTitle.MN && !isFirstLoad ? 'c-show' : ''),($parent.showActiveMenu.includes(menuTitle.PM)  || ($parent.showSubSubMenu && (menuTitle.PM == 'R' || menuTitle.PM == 'P' || menuTitle.PM == 'AGS' || menuTitle.PM == 'WEBS'|| menuTitle.PM == 'TOOLS' )) ? 'activeLvl1' : '')]">
                        <a class="c-sidebar-nav-dropdown-toggle" v-if="menuTitle.HSM == false && menuTitle.IHM == false" v-on:click="changeShowSubMenu(menuTitle.MN)">
                            <i :class="renderIcon(menuTitle.MN)"></i>
                            <!--<i class="fa fa-hand-holding-usd" v-else-if="menuTitle.MN =='D'"></i>
            <i class="fa fa-money-bill" v-else-if="menuTitle.MN =='W'"></i>
            <i class="fa fa-tag" v-else-if="menuTitle.MN =='P'"></i>-->
                            <div class="menu-Name">
                                <span>{{ menuTitle.MPI }}.</span>
                                <span>{{ getLanguageOEMI(int_OEMId,"SMB",menuTitle.MN) }}</span>
                            </div>
                            <CBadge :style="renderPendingStyle(menuTitle.MN)" class="rounded-circle ml-auto" v-if="minimize==false" id="showNotification">{{ renderPendingNumber(menuTitle.MN) }}</CBadge>
                            <CBadge :style="renderPendingStyle(menuTitle.MN)" class="rounded-circle ml-auto" v-if="minimize==true" id="showNotificationMinimize">{{ renderPendingNumber(menuTitle.MN) }}</CBadge>
                        </a>
                        <ul class="c-sidebar-nav-dropdown-items">
                            <template v-for="(menuSubmenu, index) in obj_menuTitle">
                                <span v-if="menuSubmenu.C && menuSubmenu.PM == menuTitle.MN && menuSubmenu.HSM == false && menuSubmenu.IHM == false">
                                <li class="c-sidebar-nav-item" v-if="checkModuleAccess(menuSubmenu.MN, menuTitle.MN, constAccessType.view) && menuSubmenu.IHM == false && menuSubmenu.ISF != true && menuSubmenu.MN != 'VEC' && menuSubmenu.MN != 'VEB' && menuSubmenu.MN != 'VDH' && menuSubmenu.MN != 'CRMDU' && menuSubmenu.MN != 'LCHAT' && menuSubmenu.MN != 'UM'  && menuSubmenu.MN != 'VG' && menuSubmenu.MN != 'SAGTWL' && menuSubmenu.MN != 'STWO' && menuSubmenu.MN != 'VOTSB' " v-on:click="changeShowActiveMenu(menuTitle.MN + '.' + menuSubmenu.MN)" v-bind:class="{ 'menuActive' : $parent.showActiveMenu == menuTitle.MN + '.' + menuSubmenu.MN && ($parent.showSubSubMenu !='RS6')}">
                                    <router-link :to="'/'+ menuTitle.MN + '/'+ menuSubmenu.MN">
                                        <a id="subSubMenu" class="c-sidebar-nav-link" target="_self" @click="addMenuToFavorite(menuSubmenu,checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view))">
                                            <div class="dropdown-Name">
                                                <span>{{ checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view) }}</span>
                                                <span>{{ getLanguageOEMI(int_OEMId,"SMB",menuSubmenu.MN) }}</span>
                                                <span><span v-if="!menuSubmenu.ESA && !menuSubmenu.EMA && !menuSubmenu.EAG" class="mandatory_Field">&nbsp;**</span><i :class="menuSubmenu.IFM?'fas fa-star mr-0':'far fa-star mr-0'" @click.stop="event=>addMenuToFavorite(menuSubmenu,checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view),true,event)"></i></span>
                                            </div>
                                        </a>
                                    </router-link>
                                </li>
                                <li class="c-sidebar-nav-item" v-else-if="checkModuleAccess(menuSubmenu.MN, menuTitle.MN, constAccessType.view) && menuSubmenu.MN == 'SAGTWL' && menuSubmenu.IHM == false " v-on:click="changeShowActiveMenu(menuTitle.MN + '.' + menuSubmenu.MN)" v-bind:class="{ 'menuActive' : $parent.showActiveMenu == menuTitle.MN + '.' + menuSubmenu.MN}">
                                    <router-link :to="'/'+ menuTitle.MN + '/'+ menuSubmenu.MN">
                                        <a id="subSubMenu" class="c-sidebar-nav-link" target="_self" @click="addMenuToFavorite(menuSubmenu,checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view))">
                                            <div class="dropdown-Name">
                                                <span>{{ checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view) }}</span>
                                                <span v-if="getUserInfo.AT === 4">{{ getLanguage["SMB"]["NTWL"] }}</span>
                                                <span v-else>{{ getLanguage["SMB"][menuSubmenu.MN] }}</span>
                                                <span><i :class="menuSubmenu.IFM?'fas fa-star mr-0':'far fa-star mr-0'" @click.stop="event=>addMenuToFavorite(menuSubmenu,checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view),true,event)"></i></span>
                                            </div>
                                        </a>
                                    </router-link>
                                </li>
                                <!--li class="c-sidebar-nav-item" v-else-if="checkModuleAccess(menuSubmenu.MN, menuTitle.MN, constAccessType.view) && menuSubmenu.MN == 'CRMDU'" v-on:click="changeShowActiveMenu(menuTitle.MN + '.' + menuSubmenu.MN)" v-bind:class="{ 'menuActive' : $parent.showActiveMenu == menuTitle.MN + '.' + menuSubmenu.MN}">
        <a href="/auth/crm" id="subSubMenu" class="c-sidebar-nav-link" target="_blank" @click="addMenuToFavorite(menuSubmenu,checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view))">
            <div class="dropdown-Name">
                <span>{{ checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view) }}</span>
                <span>{{ getLanguage["SMB"][menuSubmenu.MN] }}</span>
                <span><span v-if="!menuSubmenu.ESA && !menuSubmenu.EMA && !menuSubmenu.EAG" class="mandatory_Field">&nbsp;**</span><i :class="menuSubmenu.IFM?'fas fa-star mr-0':'far fa-star mr-0'" @click.stop="event=>addMenuToFavorite(menuSubmenu,checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view),true,event)"></i></span>
            </div>
        </a>
    </li>-->
                                <li class="c-sidebar-nav-item" v-else-if="(menuTitle.MN == 'D' || menuTitle.MN == 'W' || menuTitle.MN == 'P') && checkModuleAccess(menuSubmenu.MN, menuTitle.MN, constAccessType.add)" v-on:click="changeShowActiveMenu(menuTitle.MN + '.' + menuSubmenu.MN)" v-bind:class="{ 'menuActive' : $parent.showActiveMenu == menuTitle.MN + '.' + menuSubmenu.MN}">
                                    <router-link :to="'/'+ menuTitle.MN + '/'+ menuSubmenu.MN">
                                        <a id="subSubMenu" class="c-sidebar-nav-link" target="_self" @click="addMenuToFavorite(menuSubmenu,checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view))">
                                            <div class="dropdown-Name">
                                                <span>{{ checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.add) }}</span>
                                                <span>{{ getLanguage["SMB"][menuSubmenu.MN] }}</span>
                                                <span><i :class="menuSubmenu.IFM?'fas fa-star mr-0':'far fa-star mr-0'" @click.stop="event=>addMenuToFavorite(menuSubmenu,checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view),true,event)"></i></span>
                                            </div>
                                        </a>
                                    </router-link>
                                </li>
                                <!--<li class="c-sidebar-nav-item" v-else-if="checkModuleAccess(menuSubmenu.MN, menuTitle.MN, constAccessType.view) && menuSubmenu.MN == 'LCHAT'" v-on:click="changeShowActiveMenu(menuTitle.MN + '.' + menuSubmenu.MN)" v-bind:class="{ 'menuActive' : $parent.showActiveMenu == menuTitle.MN + '.' + menuSubmenu.MN}">
        <a href="/auth/LCHAT" id="subSubMenu" class="c-sidebar-nav-link" target="_blank" @click="addMenuToFavorite(menuSubmenu,checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view))">
            <div class="dropdown-Name">
                <span>{{ checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view) }}</span>
                <span>{{ getLanguage["SMB"][menuSubmenu.MN] }}</span>
                <span><i :class="menuSubmenu.IFM?'fas fa-star mr-0':'far fa-star mr-0'" @click.stop="event=>addMenuToFavorite(menuSubmenu,checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view),true,event)"></i></span>
            </div>
        </a>
    </li>-->
                                <li class="c-sidebar-nav-item" v-else-if="((menuSubmenu.MN == 'VG') || (menuSubmenu.MN == 'UM')) && checkModuleAccess(menuSubmenu.MN, menuTitle.MN, constAccessType.view) && menuSubmenu.IHM == false" v-on:click="changeShowActiveMenu(menuTitle.MN + '.' + menuSubmenu.MN)" v-bind:class="{ 'menuActive' : $parent.showActiveMenu == menuTitle.MN + '.' + menuSubmenu.MN}">
                                    <router-link :to="'/'+ menuTitle.MN + '/'+ menuSubmenu.MN" target="_blank">
                                        <a id="subSubMenu" class="c-sidebar-nav-link" target="_blank" @click="addMenuToFavorite(menuSubmenu,checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view))">
                                            <div class="dropdown-Name">
                                                <span>{{ checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view) }}</span>
                                                <span>{{ getLanguage["SMB"][menuSubmenu.MN] }}</span>
                                                <span><i :class="menuSubmenu.IFM?'fas fa-star mr-0':'far fa-star mr-0'" @click.stop="event=>addMenuToFavorite(menuSubmenu,checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view),true,event)"></i></span>
                                            </div>
                                        </a>
                                    </router-link>
                                </li>
                                </span>
                                <span v-if="menuSubmenu.PM == menuTitle.MN && menuSubmenu.HSM == true && menuSubmenu.SMN.length > 0 && checkSubModuleAccess(menuSubmenu.SMN) && menuSubmenu.IHM == false">
                                <li class="c-sidebar-nav-item c-sidebar-nav-dropdown" v-if="checkMenuAccess(menuSubmenu.MN) && menuSubmenu.IHM == false" v-on:click="changeShowSubSubMenu(menuSubmenu.SMN)" :class="[(($parent.showSubSubMenu == menuSubmenu.SMN)  ? 'menuActive c-show' : ''),($parent.showSubSubMenu.includes(menuTitle.SPM) ? 'activeLvl2' : '')]" :style="{cursor: getUserInfo.EL2MC ? 'pointer' : 'none',display: getUserInfo.EL2MC ? 'block' : 'none'}">
                                    <div class="activeLvl2Div">
                                        <a id="subSubMenu" class="c-sidebar-nav-link c-sidebar-nav-dropdown-toggle haveSubMenu" target="_self">
                                            <div class="dropdown-Name">
                                                <span>{{ checkSubModuleIndex(menuSubmenu.MPI, menuSubmenu.PM, menuSubmenu.SMN, menuSubmenu.SMI) }}</span>
                                                <span>{{ getLanguageOEMI(int_OEMId,"SMB",menuSubmenu.SMN) }}</span>
                                            </div>
                                        </a>
                                    </div>
                                </li>
                                <template v-for="(menuSubModulemenu, index) in obj_menuTitle">
                                    <span :class="!getUserInfo.EL2MC ? '' : 'level3'" v-if="menuSubModulemenu.C && menuSubModulemenu.SPM == menuSubmenu.SMN && menuSubModulemenu.HSM == true && menuSubModulemenu.IHM == false">
                                    <li class="c-sidebar-nav-item" v-if="checkModuleAccess(menuSubModulemenu.MN, menuTitle.MN, constAccessType.view) && menuSubModulemenu.IHM == false" v-on:click="changeShowActiveMenu(menuSubModulemenu.PM + '.' + menuSubModulemenu.MN)" v-bind:class="{ 'menuActive' : $parent.showActiveMenu == menuTitle.MN + '.' + menuSubModulemenu.MN, 'd-block': ($parent.showSubSubMenu == menuSubModulemenu.SPM) || !getUserInfo.EL2MC, 'd-none': ($parent.showSubSubMenu != menuSubModulemenu.SPM) || getUserInfo.EL2MC}" style="animation: fadeIn .5s; ">
                                        <router-link :to="'/'+ menuTitle.MN + '/'+ menuSubModulemenu.MN">
                                            <a id="subSubMenu" class="c-sidebar-nav-link" target="_self" @click="addMenuToFavorite(menuSubModulemenu,checkModuleIndex(menuSubModulemenu.MN, menuTitle.MN, constAccessType.view, menuSubmenu.SMN, menuSubmenu.SMI))">
                                                <div class="dropdown-Name" :class="getUserInfo.EL2MC ? 'dropdown-SubName' : ''">
                                                    <span>{{ checkModuleIndex(menuSubModulemenu.MN, menuTitle.MN, constAccessType.view, menuSubmenu.SMN, menuSubmenu.SMI) }}</span>
                                                    <span v-if="menuSubModulemenu.MN == 'DR2'">{{ getLanguageOEMI(int_OEMId,"SMB","D") }}</span>
                                                    <span v-else-if="menuSubModulemenu.MN == 'WR2'">{{ getLanguageOEMI(int_OEMId,"SMB","W") }}</span>
                                                    <span v-else>{{ getLanguageOEMI(int_OEMId,"SMB",menuSubModulemenu.MN) }}</span>
                                                    <span><i :class="menuSubModulemenu.IFM?'fas fa-star mr-0':'far fa-star mr-0'" @click.stop="event=>addMenuToFavorite(menuSubModulemenu,checkModuleIndex(menuSubModulemenu.MN, menuTitle.MN, constAccessType.view, menuSubmenu.SMN, menuSubmenu.SMI),true,event)"></i></span>
                                                </div>
                                            </a>
                                        </router-link>
                                    </li>
                                    </span>
                                </template>
                                </span>
                            </template>
                        </ul>
                    </li>

                    <!-- custom for promo rules only (simplify menu) -->
                    <li v-if="menuTitle.C == false && (menuTitle.MN == 'PRS' && menuTitle.PM == 'PRS') && menuTitle.HSM == false && menuTitle.IHM == false" :class="[($parent.showSubMenu == menuTitle.MN && !isFirstLoad ? 'c-sidebar-nav-dropdown c-show' : '')]">
                        <router-link :to="{ path:'/P/PRS', query:{ simplifymenu: 1 }}" class="c-sidebar-nav-dropdown-toggle after-none">
                            <i :class="renderIcon(menuTitle.MN)"></i>
                            <div class="menu-Name">
                                <span>{{ menuTitle.MPI }}.</span>
                                <span>{{ getLanguageOEMI(int_OEMId,"SMB",menuTitle.MN) }}</span>
                            </div>
                        </router-link>
                    </li>
                </template>
            </ul>
        </div>

        <div class="d-flex justify-content-end">
            <span class="time-indicator d-sm-down-none">{{ DateTime | moment("DD MMM YYYY h:mm:ss a") }}</span>
            <!-- Button -->
            <CSidebarMinimizer class="d-sm-down-none" @click.native="changeMinimize" style="z-index:6" />
            <!-- End Button -->
        </div>

    </CSidebar>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import genericHelper from "../../modules/GenericHelper.js";
    import { constAccessType, constMenuIcon } from '@/modules/Constant.js';
    import moment from "moment";
    import Vue from 'vue'
    import $ from 'jquery'

    export default {
        mixins: [genericHelper],
        name: 'SideMenuBar',
        props: ['isSimpleMode'],
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkMenuAccess', 'checkModuleAccess', 'checkModuleIndex', 'checkSubModuleAccess', 'checkSubModuleIndex']),
            ...mapGetters('DashboardData', [
                'getPendingDeposit',
                'getPendingWithdrawal',
                'getPendingPromotion',
                'getPendingAutoDepositPlus'
            ]),
            ...mapGetters('SMBData', [
                'getCurrencySymbol',
                'getSystemBalance',
                'getCreditBalance',
                'getBalanceStatus',
                'getCurrencyCode'
            ]),
        },
        data() {
            return {
                minimize: false,
                isMinimize: false,
                hover: false,
                breakpoint: 'md',
                int_OEMId: 0,
                show: 'responsive',
                obj_menuTitle: {},
                favMenuList: [],
                //arry_cutmMN: ["AFF","AFFS","AFFL","AFFEL","DASH"],
                constAccessType: constAccessType,
                constMenuIcon: constMenuIcon,
                AutoUpdateTO: null,
                SystemBalance: null,
                CurrencySymbol: null,
                DateTime: this.getTodayDate(),
                timeout: [],
                isOUTMOB: '',
                isFirstLoad: true,
                simplifyMenuItemSPA: ['ANAA', 'ANAN', 'ANMAN', 'ANMNT', 'ANSAN', 'ANSNT', 'LBAL', 'LDL', 'LL', 'LMEMWL', 'LMMWL', 'LMLO', 'LPL', 'LALO', 'LVLO', 'LWL', 'RR', 'RTWLBAG', 'SYSAL', 'SYSCRR', 'SYSSYS'],
                simplifyMenuItemSM: ['AGSAGS', 'AGSAGD', 'AGSASS', 'ANAA', 'ANAN', 'ANSAN', 'ANSNT', 'DASHDASH', 'DASHDBM', 'DASHDBP', 'RR', 'RTAS', 'RTWLBAG', 'RTWLBMA', 'RTWL', 'SYSSYS', 'SYSAL', 'SYSCRR', 'RBTL', 'RDR2', 'RWR2', 'RTR', 'RLR', 'RA1188FR', 'RABRBM'],
                simplifyMenuItemMA: ['AGSAGS', 'AGSAGD', 'AGSASS', 'ANAA', 'ANAN', 'ANSAN', 'ANSNT', 'DASHDASH', 'DASHDBM', 'DASHDBP', 'RR', 'RTAS', 'RTWLBAG', 'RTWLBMA', 'RTWL', 'SYSSYS', 'SYSAL', 'SYSCRR', 'RBTL', 'RDR2', 'RWR2', 'RTR', 'RLR', 'RA1188FR', 'RABRBM'],
                simplifyMenuItemA: ['CC', 'CCAL', 'CMDC', 'CMWC', 'CMWL', 'CCTS', 'CTNC', 'CCTL', 'CCL', 'AFFAFF', 'AFFAFFS', 'AGSAGS', 'AGSAGD', 'AGSASS', 'AGSGPLCBA', 'ANAA', 'ANAN', 'BB', 'WEBSWEBS', 'BACL', 'BMWB', 'DASHDASH', 'DASHDBM', 'DASHDBO', 'DD', 'DDDU', 'DDR', 'WWDU', 'WWR', 'GSGS', 'GSGSDU', 'MBLL', 'MM', 'MMCMI', 'MML', 'MMTS', 'MPAP', 'PDLSS', 'PLYT', 'PMSA', 'PP', 'PPD', 'PPDU', 'PPSE', 'RDR2', 'PTNMT', 'REBD', 'RR', 'RPR', 'RTR', 'RTAS', 'RTWLBAG', 'RTWL', 'RTWLBMA', 'RWINLV2', 'RWR2', 'SYSSYS', 'SYSAL', 'SYSCRR', 'WEBS', 'WEBSBA', 'WEBSCS', 'WEBSCMSDU', 'WEBSLC', 'WEBSPV', 'WW'],
            }
        },
        methods: {
            ...mapActions('SMBData', [
                'setCurrencySymbol',
                'setSystemBalance',
                'setCreditBalance',
                'setBalanceStatus',
                'setCurrencyCode'
            ]),
            ...mapActions('UserInfo', ['setMenuDisplayType']),
            changeMinimize() {
                this.isMinimize = !this.isMinimize;
                if (this.isMinimize) {
                    this.minimize = true;
                    $(".time-indicator").addClass('d-none');
                    $(".version").addClass('d-none');
                } else if (!this.isMinimize) {
                    this.minimize = false;
                    $(".time-indicator").removeClass('d-none');
                    $(".version").removeClass('d-none');
                }
            },
            changeShowSubMenu(MN) {
                this.$route.matched[0].name = this.getLanguage["SMB"][MN];
                
                if (this.$parent.showSubMenu == MN && !this.isFirstLoad) {
                    this.$parent.showSubMenu = '';
                } else {                    
                    this.$parent.showSubMenu = MN;
                }
                this.isFirstLoad = false;
            },
            changeShowSubSubMenu(SMN) {
                if (this.$parent.showSubSubMenu == SMN) {
                    this.$parent.showSubSubMenu = '';
                } else {
                    this.$parent.showSubSubMenu = SMN;
                }                
            },
            changeShowActiveMenu(MN) {
                this.$parent.showActiveMenu = MN;                
                this.$notify({ clean: true, group: 'msgNotification' });

                if (this.$parent.showSubSubMenu == 'RS6' && this.$parent.showSubMenu != 'GS') {
                    this.$parent.showSubSubMenu = '';
                }

                if (!this.isOUTMOB) {
                    if (!this.$parent.showSubSubMenu) {
                        this.changeShowSubSubMenu('RS1')
                    }
                }                
                else {
                    this.changeShowSubSubMenu('RS3')
                }    


                //Game Settings collapse sub menu when click on other menu
                if (MN.split(".")[0] == "GS" && (
                    MN.split(".")[1] != "GPS" && MN.split(".")[1] != "M888S" &&
                    MN.split(".")[1] != "MV3S" && MN.split(".")[1] != "P888S" &&
                    MN.split(".")[1] != "K918S" && MN.split(".")[1] != "A288S" &&
                    MN.split(".")[1] != "AFBCS" && MN.split(".")[1] != "LG88S" &&
                    MN.split(".")[1] != "GD88S" && MN.split(".")[1] != "IGS" &&
                    MN.split(".")[1] != "NKS" && MN.split(".")[1] != "W9S"
                )) {
                    if (!this.isOUTMOB) {
                        this.changeShowSubSubMenu('RS1');
                    }
                    else {
                        this.changeShowSubSubMenu('RS3');
                    }
                } 
                

                // when click report will auto minimize sidemenu
                if (MN.split(".")[0] == "R") {
                    this.isMinimize = true;
                    this.minimize = true;
                    $(".time-indicator").addClass('d-none');
                    $(".version").addClass('d-none');
                } else {
                    this.isMinimize = false;
                    this.minimize = false;
                    $(".time-indicator").removeClass('d-none');
                    $(".version").removeClass('d-none');
                }
            },
            getFromSystemBalance() {
                var that = this;

                if (sessionStorage.getItem('tabId') === localStorage.getItem('tabId')) {
                    this.getDataApi(`/api/ag/gcag`,
                        function (d, s) {
                            if (s) {
                                that.setCurrencySymbol(d.D.CS);
                                that.setSystemBalance(d.D.SB);
                                that.setCreditBalance(d.D.CB2);
                                that.setBalanceStatus(d.D.BS);
                                that.setCurrencyCode(d.D.ISOC);

                                //Store in localstorage for remaining tabs
                                localStorage.setItem('CS', d.D.CS);
                                localStorage.setItem('SB', d.D.SB);
                                localStorage.setItem('CB', d.D.CB2);
                                localStorage.setItem('BS', d.D.BS);
                                localStorage.setItem('ISOC', d.D.ISOC);
                            }
                        });
                }
                else {                    
                    that.setCurrencySymbol(localStorage.getItem('CS'));
                    that.setSystemBalance(localStorage.getItem('SB'));
                    that.setCreditBalance(localStorage.getItem('CB'));
                    that.setBalanceStatus(localStorage.getItem('BS'));
                    that.setCurrencyCode(localStorage.getItem('ISOC'));
                }                
            },
            getmenuTitle(isSimpleMode) {
                var that = this;
                //this.getDataApi(`/api/role/g/0`,
                this.getDataApi(`/api/role/gv/0/0/` + isSimpleMode,
                    function (d, s) {
                        if (s) {
                            that.setmenuTitle(d);
                        }
                    });
            },
            setmenuTitle(data) {
                this.obj_menuTitle = data.RoleAccessList;
                if (data.FavMenuList != null && data.FavMenuList.length > 0) {
                    var favMenuCount = 0;
                    this.favMenuList = [];
                    for (var i = 0; i < data.FavMenuList.length; i++) {
                        if (favMenuCount == 5)
                            break;
                        else if (this.checkModuleAccess(data.FavMenuList[i].MN, data.FavMenuList[i].PM, this.constAccessType.view)) {
                            this.favMenuList.push(data.FavMenuList[i]);
                            favMenuCount++;
                        }
                    }
                }
                //this.favMenuList = data.FavMenuList;
                if (this.isOUTMOB) {
                    var that = this;
                    var tempMenu = []; // temperory hide menu in outlet mobile
                    $.each(that.obj_menuTitle, function (index, elem) {
                        if (elem.PM == "DASH" || elem.PM == "P" || (elem.PM == "R" && elem.SMN == "RS2") || (elem.PM == "R" && elem.MN == "WINLV2") || (elem.PM == "R" && elem.MN == "SAGTWL") || (elem.PM == "R" && elem.SMN == "RS4") || elem.PM == "AFF" || elem.PM == "MS" || elem.PM == "L" || elem.PM == "D" || elem.PM == "W" || (elem.PM == "M" && elem.MN == "BLL") || (elem.PM == "GS" && elem.MN == "GSDU") || (elem.PM == "AGS" && elem.MN == "SUBHRY") ||elem.ISF == true) {
                        } else {
                            tempMenu.push(elem)
                        }                        
                    });
                    that.obj_menuTitle = tempMenu;          
                }

                if (this.$route.path == "/") {
                    var ParentModule = "";
                    var ModuleName = "";
                    for (var i = 0; i < this.obj_menuTitle.length; i++) {
                        if (this.obj_menuTitle[i].C && this.checkModuleAccess(this.obj_menuTitle[i].MN, this.obj_menuTitle[i].PM, constAccessType.view) && this.obj_menuTitle[i].MN != 'VEC' && this.obj_menuTitle[i].MN != 'VEB' && this.obj_menuTitle[i].MN != 'VDH' && this.obj_menuTitle[i].MN != 'VOTSB') {
                            var link = '/' + this.obj_menuTitle[i].PM + '/' + this.obj_menuTitle[i].MN;
                            ParentModule = this.obj_menuTitle[i].PM;
                            ModuleName = this.obj_menuTitle[i].MN;
                            this.$router.push(link);
                            break;
                        }
                    }
                    this.isFirstLoad = (this.favMenuList != null && this.favMenuList.length > 0 && this.favMenuList.find(f => { return f.PM == ParentModule && f.MN == ModuleName }));
                }
                else {
                    var temp = this.$parent.showActiveMenu.split('.');
                    var ParentModule = "";
                    var ModuleName = "";
                    if (temp.length > 0) {
                        ParentModule = temp[0];
                        ModuleName = temp[1];
                    }
                    this.isFirstLoad = (this.favMenuList != null && this.favMenuList.length > 0 && this.favMenuList.find(f => { return f.PM == ParentModule && f.MN == ModuleName }));
                }

                for (var i = 0; i < this.obj_menuTitle.length; i++) {                    
                    if (this.obj_menuTitle[i].C && this.checkModuleAccess(this.obj_menuTitle[i].MN, this.obj_menuTitle[i].PM, constAccessType.view) && this.obj_menuTitle[i].MN != 'VEC' && this.obj_menuTitle[i].MN != 'VEB' && this.obj_menuTitle[i].MN != 'VDH' && this.obj_menuTitle[i].MN != 'VOTSB'&& this.obj_menuTitle[i].ISF ==false ) {
                        var link = '/' + this.obj_menuTitle[i].PM + '/' + this.obj_menuTitle[i].MN;
                        this.$parent.FisrtMenuItem = link;
                        break;
                    }
                }

                //TT11599 [BO Customize Menu] Enhance on Customize Menu
                //if (this.getUserInfo.AT == 1 || this.getUserInfo.AT == 2) {
                //    if (this.obj_menuTitle.length > 0) {
                //        this.obj_menuTitle = this.obj_menuTitle.filter(function (item) {
                //            return item.SMN !== "RS2";
                //        });
                //    }
                //}

                if (this.getUserInfo.MS === 1) {
                    this.obj_menuTitle.forEach(item => { item.IHM = false; });
                }
                else if (this.getUserInfo.MS === 2) {
                    let simplifyMenuList = this.getSimplifyList();
                    const simplifySet = new Set(simplifyMenuList);
                    this.obj_menuTitle.forEach(item => {
                        const isParent = item.MN === item.PM;
                        const key = item.PM + item.MN;
                        const shouldShow = simplifySet.has(key);
                        item.IHM = isParent ? !shouldShow : !shouldShow;
                    });
                }
                
                this.$parent.bool_fullpageLoading = false;
            },
            renderIcon(menuTitle) {
                return this.constMenuIcon[menuTitle];
            },
            renderPendingStyle(menuTitle) {
                if (menuTitle == 'D' && this.getPendingDeposit > 99) {
                    return { 'background-color': '#30878e', 'font-size': '8.5px' };
                } else if (menuTitle == 'W' && this.getPendingWithdrawal > 99) {
                    return { 'background-color': '#e53636', 'font-size': '8.5px' };
                } else if (menuTitle == 'P' && this.getPendingPromotion > 99) {
                    return { 'background-color': '#6f6bd6', 'font-size': '8.5px' };
                } else if (menuTitle == 'D') {
                    return { 'background-color': '#30878e' };
                } else if (menuTitle == 'W' || (menuTitle == 'B' && this.getPendingAutoDepositPlus > 0)) {
                    return { 'background-color': '#e53636' };
                } else if (menuTitle == 'P') {
                    return { 'background-color': '#6f6bd6' };
                }
            },
            renderPendingNumber(menuTitle) {
                if (menuTitle == 'D') {
                    return (this.getPendingDeposit <= 99) ? this.getPendingDeposit : '99+';
                } else if (menuTitle == 'W') {
                    return (this.getPendingWithdrawal <= 99) ? this.getPendingWithdrawal : '99+';
                } else if (menuTitle == 'P') {
                    return (this.getPendingPromotion <= 99) ? this.getPendingPromotion : '99+';
                } else if (menuTitle == 'B' && this.getPendingAutoDepositPlus > 0) {
                    return (this.getPendingAutoDepositPlus <= 99) ? this.getPendingAutoDepositPlus : '99+';
                }
            },
            AutoUpdate() {
                this.nextUpdate();
                var that = this;
                this.AutoUpdateTO = setTimeout(function () {
                    that.AutoUpdate();
                }, 10000);
            },
            nextUpdate: function () {
                this.getFromSystemBalance();
            },
            getDate() {
                var self = this;
                self.DateTime = new Date();
                self.timeout[0] = setTimeout(() => {
                    self.getDate();
                }, 1000);
            },
            copyReferralLink: function () {
                var inp = document.createElement('input');
                document.body.appendChild(inp)
                inp.value = this.getUserInfo.SARL;
                inp.select();
                document.execCommand('copy', false);
                inp.remove();

                Vue.notify({
                    group: 'msgNotificationTop',
                    type: 'success',
                    // title: 'Title',
                    text: this.getLanguage['GL']['CPSC'],
                    duration: 2000
                });
            },
            onHandleWindowResize() {
                var $win = $(window);
                this.windowWidth = $win.width();
                this.windowHeight = $win.height();

                if (this.windowWidth >= 768 && !this.isMinimize) {
                    this.minimize = false;
                    $(".time-indicator").removeClass('d-none');
                    $(".version").removeClass('d-none');
                } else if (this.windowWidth < 768) {
                    this.minimize = false;
                    $(".time-indicator").addClass('d-none');
                    $(".version").addClass('d-none');
                } else {
                    this.minimize = true;
                    $(".time-indicator").addClass('d-none');
                    $(".version").addClass('d-none');
                }
            },
            redirectToCreditHistory() {
                if (this.getUserInfo.AT === 4) {
                    this.$router.push("/AGS/SubAgentCreditHistory?agi=4-" + this.getUserInfo.AGI + '&iol=' + (this.getUserInfo.IOL ? '1' : '0'));
                }
            },
            addMenuToFavorite(Menu, MenuIndexDisplay, checkFavorite = false, event = null, ClickdFromFav = false) {
                if (event) {
                    event.preventDefault();
                }
                if (checkFavorite) {
                    Menu.IFM = !Menu.IFM;
                }
                this.isFirstLoad = ClickdFromFav;
                if (ClickdFromFav) {
                    const temp = this.obj_menuTitle.find(f => { return f.PM == Menu.PM && f.MN == Menu.MN });
                    if (temp) {
                        temp.IFM = Menu.IFM;
                    }
                } else {
                    const temp = this.favMenuList.find(f => { return f.PM == Menu.PM && f.MN == Menu.MN });
                    if (temp) {
                        temp.IFM = Menu.IFM;
                    }
                }
                var that = this;
                this.postDataApi(`/api/role/add-fav`, { 'PM': Menu.PM, 'MN': Menu.MN, 'IFM': Menu.IFM, 'FAVBTN': checkFavorite, 'MID': MenuIndexDisplay },
                    function (d, s) {
                        if (d && !d.S) {
                            Menu.IFM = !Menu.IFM;
                            that.showErrorMessage(null, that.getLanguage["FAV"]["MAXMENU"]);
                        }
                    });
            },
            getSimplifyList() {
                const AT = this.getUserInfo.AT;
                if (AT === 0) return this.simplifyMenuItemSPA;
                if (AT === 1) return this.simplifyMenuItemSM;
                if (AT === 2) return this.simplifyMenuItemMA;
                if (AT === 3) return this.simplifyMenuItemA;
                return [];
            },
        },
        watch: {
            hover() {
                if (this.isMinimize) {
                    this.minimize = true;
                    $(".time-indicator").addClass('d-none');
                    $(".version").addClass('d-none');
                } else if (!this.isMinimize) {
                    this.minimize = false;
                    $(".time-indicator").removeClass('d-none');
                    $(".version").removeClass('d-none');
                }
                if (this.hover && this.isMinimize) {
                    this.minimize = false;
                    $(".time-indicator").removeClass('d-none');
                    $(".version").removeClass('d-none');
                }
            },
            isSimpleMode() {
                this.obj_menuTitle = {};
                this.favMenuList = [];
                this.$parent.bool_fullpageLoading = true;
                if (this.isSimpleMode) {
                    localStorage.setItem('isSimpleMode', 'True');
                    this.setMenuDisplayType(1)
                    this.getmenuTitle(1);
                } else {
                    localStorage.setItem('isSimpleMode', 'False');
                    this.setMenuDisplayType(0)
                    this.getmenuTitle(0);
                }
            },
        },
        beforeRouteLeave(to, from, next) {
            clearTimeout(this.AutoUpdateTO);
            next();
        },
        mounted() {
            this.onHandleWindowResize();
            window.addEventListener("resize", this.onHandleWindowResize);
            this.int_OEMId = this.getUserInfo.OEMI;
            this.$root.$on('toggle-sidebar', () => {
                const sidebarOpened = this.show === true || this.show === 'responsive'
                this.show = sidebarOpened ? false : 'responsive'
            })
            this.$root.$on('toggle-sidebar-mobile', () => {
                const sidebarClosed = this.show === 'responsive' || this.show === false
                this.show = sidebarClosed ? true : 'responsive'
            })

            if (localStorage.getItem('isOutletMobile') === null) {
                if (this.getUserInfo.IOL && this.getUserInfo.IMD) {
                    localStorage.setItem('isOutletMobile', 'True');
                    document.getElementById('changeView').className = "view-desktop";
                } else {
                    localStorage.setItem('isOutletMobile', 'False');
                    document.getElementById('changeView').className = "view-mobile";
                }
            } else if (localStorage.getItem('isOutletMobile') == 'True' && this.getUserInfo.IOL && this.getUserInfo.IMD) {
                localStorage.setItem('isOutletMobile', 'True');
                document.getElementById('changeView').className = "view-desktop";
            } else {
                localStorage.setItem('isOutletMobile', 'False');
                document.getElementById('changeView').className = "view-mobile";
            }
            this.isOUTMOB = (localStorage.getItem('isOutletMobile') == 'True') ? true : false;

            this.getFromSystemBalance();
            if (localStorage.getItem('isSimpleMode') === 'False') {
                this.$parent.isSimpleMode = false;
                this.setMenuDisplayType(0)
                this.getmenuTitle(0);
            } else {
                this.$parent.isSimpleMode = true;
                this.setMenuDisplayType(1)
                this.getmenuTitle(1);
            }
            this.AutoUpdate();
            this.getDate();
            this.changeShowActiveMenu(this.$parent.showActiveMenu);

        },
    }
</script>

<style scoped>
    .blobs-container {
        display: flex;
    }

    .blob {
        background: transparent;
        border-radius: 50%;
        box-shadow: 0 0 0 0 rgba(169, 173, 204, 1);
        margin-right: 15px;
        margin-left: 4px;
        height: 20px;
        width: 20px;
        transform: scale(1);
        animation: pulse-ssa 3s infinite;
    }
    .blob:hover {
        animation: pulse-ssa 3s infinite;
    }
    @keyframes pulse-ssa {
        0% {
            transform: scale(0.95);
            box-shadow: 0 0 0 0 rgba(169, 173, 204, 0.7);
        }

        70% {
            transform: scale(1);
            box-shadow: 0 0 0 5px rgba(169, 173, 204, 0);
        }

        100% {
            transform: scale(0.95);
            box-shadow: 0 0 0 0 rgba(169, 173, 204, 0);
        }
    }
    .freeze-user {
        background: #8ce1f6;
        color: #0c1033 !important;
        font-weight: 600;
        padding: 0.25rem 0rem 0.25rem .5rem;
        border-radius: 5px;
    }
    .cil-snowflake.freeze {
        padding: .25rem .0rem;
        margin-right: 0 !important;
        font-size: 13px;
        color: #0c1033 !important;
        width: 20px !important;
        height: 15px !important;
        align-items: unset !important;
        display: flex;
    }

    .new-profile {
        gap: 10px;
        display: grid;
        grid-template-columns: 1fr 4fr;
        align-items: center;
    }

    .new-profile-iconbg {
        background: #3A3F69;
        border-radius: 5px;
        width: 60px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .new-profile-iconbg .custom_tooltip  span{
        transform:scale(1.25)
    }
    .rounded-icon {
        height: 24px;
        border-radius: 7px;
        font-size: 12px;
        line-height: 12px;
        color: #fff;
        text-align: center;
        text-transform: uppercase;
        font-weight: 500;
        display: flex;
        justify-content: space-between;
        padding: 0px 15px;
        font-family: 'Poppins';
        align-items: center;
    }
            .rounded-icon svg {
                fill: #000;
                width: 15px;
                height: 15px;
                margin-right: 0px;
            }
        .rounded-icon:hover, .rounded-icon.active {
            background: #3A3F69;
        }
    .rounded-icon:hover svg {
        fill: #adb8c9;
    }
    .rightline:after {
        content: "";
        background: #000;
        position: absolute;
        bottom: 0;
        left: 0;
        height: 22px;
        width: 2px;
        top: 5px;
    }
    .c-sidebar-minimized .user-profile{
        display:none;
    }
    .menuOption {
        background: #292C4D; height: 36px; padding: 6px 4px ;
    }

    .rounded-icon .badge {
        width: 15px;
        height: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/SideMenuBar.vue